export const detectTimesheetIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * --------e-------------------------- */
    if (cleaned === "delete timesheet" || cleaned === "remove timesheet") {
        return { intent: "delete_timesheet" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) timesheet/);
    if (deleteMatch) {
        return { intent: "delete_timesheet", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create timesheet") || cleaned.includes("add timesheet")) {
        return { intent: "create_timesheet" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create timesheet named (.+)/);
    if (createMatch) {
        return { intent: "create_timesheet", name: createMatch[1].trim() };
    }

    return null;
};
